
import { gmapApi } from 'vue2-google-maps'

export default {
  props: {
    hotel: {
      type: Object,
      required: true,
    },
    toHotel: {
      type: Object,
      default: null,
    },
    icon: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      options: {
        zoom: 16,
        mapId: null,
        scrollwheel: true,
        clickableIcons: false,
        disableDefaultUI: true,
        gestureHandling: 'greedy',
        zoomControl: true,
        scaleControl: true,
        zoomControlOptions: {
          position: this.dir === 'ltr' ? 8 : 4,
        },
        directionsRenderer: null,
      },
    }
  },
  fetch() {
    this.options.mapId =
      this.colorMode === 'dark'
        ? this.$config.googleMapDarkId
        : this.$config.googleMapLightId
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    colorMode(value) {
      this.options.mapId =
        value === 'dark'
          ? this.$config.googleMapDarkId
          : this.$config.googleMapLightId
    },
    toHotel(value) {
      this.setMarker(value)
    },
  },
  methods: {
    setMarker(item) {
      const bounds = new this.google.maps.LatLngBounds()
      bounds.extend(item.geometry.location)
      bounds.extend(this.hotel._geoloc)
      this.$refs.gmap.fitBounds(bounds, 20)
      this.calcRoute()
    },
    calcRoute() {
      const directionsService = new this.google.maps.DirectionsService()

      if (!this.directionsRenderer) {
        this.directionsRenderer = new this.google.maps.DirectionsRenderer({
          suppressMarkers: true,
          polylineOptions: {
            strokeColor: this.whiteLabel.colors.brand.light,
            strokeWeight: 1,
          },
        })
      }

      this.directionsRenderer.setMap(null)

      const request = {
        origin: this.hotel._geoloc,
        destination: this.toHotel.geometry.location,
        travelMode: 'DRIVING',
      }

      directionsService.route(request, (result, status) => {
        if (status === 'OK') {
          this.directionsRenderer.setDirections(result)
          this.directionsRenderer.setMap(this.$refs.gmap.$mapObject)
        }
      })
    },
  },
}
